import { useNavigate } from "react-router-dom";
import { StatusBadge } from "./StatusBadge";
import { FavoriteButton } from "./FavoriteButton";
import { useLanguage } from "@/i18n/LanguageContext";

export const EventCard = ({ event, className = "" }) => {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  // day_label / month viennent du backend en français — recalculés selon la langue
  const d = event.date ? new Date(`${event.date}T12:00:00`) : null;
  const dayLabel = lang === "en" && d ? new Intl.DateTimeFormat("en-CA", { weekday: "short" }).format(d) : event.day_label;
  const monthLabel = lang === "en" && d ? new Intl.DateTimeFormat("en-CA", { month: "short" }).format(d) : event.month;
  return (
    <article
      data-testid={`event-card-${event.slug}`}
      onClick={() => navigate(`/evenement/${event.slug}`)}
      className={`group flex cursor-pointer items-center gap-4 rounded-2xl border border-slate-100 bg-white p-4 shadow-[0_4px_16px_rgba(15,23,42,0.05)] transition duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-[0_12px_28px_rgba(37,99,235,0.12)] ${className}`}
    >
      <div className="flex w-12 shrink-0 flex-col items-center">
        <span className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">{dayLabel}</span>
        <span className="text-xl font-extrabold leading-tight text-slate-900">{event.day}</span>
        <span className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">{monthLabel}</span>
      </div>
      <img
        src={event.image}
        alt={event.title}
        loading="lazy"
        className="h-[72px] w-[72px] shrink-0 rounded-xl object-cover sm:h-20 sm:w-20"
      />
      <div className="min-w-0 flex-1 space-y-0.5">
        <h3 className="truncate text-sm font-semibold text-slate-900">{event.title}</h3>
        <p className="truncate text-xs text-slate-500">{event.venue}</p>
        <p className="truncate text-xs text-slate-400">{event.meta}</p>
        <StatusBadge badge={event.badge} soft />
      </div>
      <FavoriteButton item={event} itemType="evenement" inline />
    </article>
  );
};
